import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography, Grid } from "@mui/material";
import { useTheme, lighten } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";

import {
  Container,
  CounterDetailsContainer,
  CounterDetail,
  CounterDetailDays,
  CounterDetailTitle,
  BalanceContainer,
  SegmentsContainer,
  Segment,
} from "./styles";
import { COLORS } from "../../../_globalStore/redux/reducers/Theme/themeConstants";
import { TnACounterDTO } from "../../../models/tna";

const TnACounter = ({ counter, smallSize = false }: { counter: TnACounterDTO; smallSize?: boolean }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const tRP = "components.my_calendar";

  return (
    <Container>
      <Grid
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          width: "80%",
        }}
      >
        <SegmentsContainer>
          {counter.fromPrevYear !== 0 && (
            <Segment
              style={{
                backgroundColor: COLORS.yellow_gradients.yellow,
                width: `${(counter.fromPrevYear / Math.abs(counter.balance)) * 100}%`,
              }}
            />
          )}
          {counter.generatedThisYear !== 0 && (
            <Segment
              style={{
                backgroundColor: theme.palette.primary.light,
                width:
                  counter.generatedThisYear > 0
                    ? `${(counter.generatedThisYear / Math.abs(counter.balance)) * 100}%`
                    : "0%",
              }}
            />
          )}
          {counter.correctionsThisYear !== 0 && (
            <Segment
              style={{
                backgroundColor: theme.palette.primary.main,
                width:
                  counter.correctionsThisYear > 0
                    ? `${(counter.correctionsThisYear / Math.abs(counter.balance)) * 100}%`
                    : "0%",
              }}
            />
          )}
          {counter.usedOrPlanned !== 0 && (
            <Segment
              style={{
                backgroundColor: lighten(theme.palette.error.light, 0.3),
                width:
                  counter.usedOrPlanned > 0 ? `${(counter.usedOrPlanned / Math.abs(counter.balance)) * 100}%` : "0%",
              }}
            />
          )}
        </SegmentsContainer>

        <CounterDetailsContainer>
          <CounterDetail>
            <CounterDetailTitle>
              <FontAwesomeIcon
                icon={faCircle}
                style={{ color: COLORS.yellow_gradients.yellow }}
              />
              <Typography>{`${t(`${tRP}.fields.from_previous_year`)}`}</Typography>
            </CounterDetailTitle>
            <CounterDetailDays>
              <Typography variant={smallSize ? "h5" : "h4"}>{`${Number(counter.fromPrevYear).toFixed(2)} `}</Typography>
            </CounterDetailDays>
            <Typography variant="body2">{`${t(`${tRP}.days`)}`}</Typography>
          </CounterDetail>

          <CounterDetail>
            <CounterDetailTitle>
              <FontAwesomeIcon
                icon={faCircle}
                style={{ color: theme.palette.primary.light }}
              />
              <Typography>
                {`${t(`${tRP}.fields.already_generated_this_year`)}` + ` ${t(`${tRP}.fields.in`)} ${counter.year}`}
              </Typography>
            </CounterDetailTitle>
            <CounterDetailDays>
              <Typography variant={smallSize ? "h5" : "h4"}>{`${Number(counter.generatedThisYear).toFixed(
                2
              )} `}</Typography>
            </CounterDetailDays>
            <Typography variant="body2">{`${t(`${tRP}.days`)}`}</Typography>
          </CounterDetail>

          <CounterDetail>
            <CounterDetailTitle>
              <FontAwesomeIcon
                icon={faCircle}
                style={{ color: theme.palette.primary.main }}
              />
              <Typography>
                {`${t(`${tRP}.fields.corrections`)}` + ` ${t(`${tRP}.fields.in`)} ${counter.year}`}
              </Typography>
            </CounterDetailTitle>
            <CounterDetailDays>
              <Typography variant={smallSize ? "h5" : "h4"}>{`${Number(counter.correctionsThisYear).toFixed(
                2
              )} `}</Typography>
            </CounterDetailDays>
            <Typography variant="body2">{`${t(`${tRP}.days`)}`}</Typography>
          </CounterDetail>

          <CounterDetail>
            <CounterDetailTitle>
              <FontAwesomeIcon
                icon={faCircle}
                style={{ color: lighten(theme.palette.error.light, 0.3) }}
              />
              <Typography>
                {`${t(`${tRP}.fields.already_used_or_planned`)}` + ` ${t(`${tRP}.fields.in`)} ${counter.year}`}
              </Typography>
            </CounterDetailTitle>
            <CounterDetailDays>
              <Typography variant={smallSize ? "h5" : "h4"}>{`${Number(counter.usedOrPlanned).toFixed(
                2
              )} `}</Typography>
            </CounterDetailDays>
            <Typography variant="body2">{`${t(`${tRP}.days`)}`}</Typography>
          </CounterDetail>
        </CounterDetailsContainer>
      </Grid>
      <BalanceContainer>
        <CounterDetailTitle style={{ justifyContent: "center" }}>
          <Typography style={{ textAlign: "center" }}>
            {`${t(`${tRP}.fields.total_balance`)}` + ` ${t(`${tRP}.fields.in`)} ${counter.year}`}
          </Typography>
        </CounterDetailTitle>
        <CounterDetailDays>
          <Typography variant={smallSize ? "h5" : "h4"}>{`${Number(counter.balance).toFixed(2)} `}</Typography>
        </CounterDetailDays>
        <Typography variant="body2">{`${t(`${tRP}.days`)}`}</Typography>
      </BalanceContainer>
    </Container>
  );
};
export default TnACounter;
